
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ECv0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e438ed559ad5b02f$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $jfasb = parcelRequire("jfasb");

var $8Vh1q = parcelRequire("8Vh1q");

var $ggg5j = parcelRequire("ggg5j");
const $e438ed559ad5b02f$var$buildQueryParamsForConnectAPI = async (routerContext)=>{
    const { query: query, route: route, dependencies: dependencies } = routerContext;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { loading: loading, data: data, promise: promise, error: error } = dependencies?.[(0, $ggg5j.staticProjectSidebarNavigationResource).type];
    const sidebarData = loading && promise ? await promise : data;
    const projectContext = sidebarData && (0, $8Vh1q.extractContext)(sidebarData);
    if (projectContext == null || error) throw new Error(`Unable to get container context on ${route.name ?? ''} with error ${error}`);
    return {
        ...query,
        ...projectContext
    };
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e438ed559ad5b02f$export$2e2bcd8739ae039 = async (routerContext)=>{
    const { query: query } = routerContext;
    try {
        const { addonKey: addonKey, moduleKey: moduleKey } = (0, $8Vh1q.transformUrlToAddonAndModuleKeys)(query);
        const queryParams = await $e438ed559ad5b02f$var$buildQueryParamsForConnectAPI(routerContext);
        const data = await (0, $jfasb.default)('', addonKey, moduleKey, queryParams);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('spa.router.resources.connect.projects', 'fetchData', e);
        throw e;
    }
};

});
parcelRegister("jfasb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d96b3d0555101d8$export$2e2bcd8739ae039);

var $uPntJ = parcelRequire("uPntJ");

var $8Vh1q = parcelRequire("8Vh1q");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9d96b3d0555101d8$export$2e2bcd8739ae039 = async (baseUrl, addonKey, moduleKey, queryParams = {})=>(0, $uPntJ.default)(baseUrl, addonKey, moduleKey, queryParams).then((0, $8Vh1q.transformResponse));

});
parcelRegister("uPntJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6777008b9e9f43ee$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $7f4tk = parcelRequire("7f4tk");
const $6777008b9e9f43ee$export$7138c24907de3954 = (baseUrl, addonKey, moduleKey, queryParams)=>`${baseUrl}/plugins/servlet/ac/${addonKey}/${moduleKey}?classifier=json&${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryParams)}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6777008b9e9f43ee$export$2e2bcd8739ae039 = (baseUrl, addonKey, moduleKey, queryParams)=>(0, $7f4tk.default)($6777008b9e9f43ee$export$7138c24907de3954(baseUrl, addonKey, moduleKey, queryParams), {
        method: 'POST'
    });

});




//# sourceMappingURL=async-resource-connect-addon-projects.a1ede651.js.map
